import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../../common/utils';
import { CompartmentUserListFacade } from './compartment-user-list.facade';

@Injectable({
  providedIn: 'root',
})
export class CompartmentUserListGuard {
  constructor(private compartmentUserListFacade: CompartmentUserListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.compartmentUserListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.compartmentUserListFacade);
  }
}
